// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfh_a bhf_wh bhf_sq bhf_xj"};